<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input
          v-model="searchForm.name"
          placeholder="模板名称"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.state" clearable placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getSmsTemplateList">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addSmsTemplate">申请短信模板</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe>

      <el-table-column
        prop="name"
        label="模板名称"
        width="150">
      </el-table-column>
      <el-table-column
        prop="code"
        label="模板CODE"
        width="150">
      </el-table-column>
      <el-table-column
        prop="type"
        label="模板类型"
        width="120">
        <template slot-scope="scope">
          <el-tag size="small" v-if="scope.row.type == 0">验证码</el-tag>
          <el-tag size="small" v-else-if="scope.row.type == 1">短信通知</el-tag>
          <el-tag size="small" v-else-if="scope.row.type == 2">推广短信</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="模板内容"
        width="500">
      </el-table-column>
      <el-table-column
        prop="state"
        label="审核状态"
        width="120">
        <template slot-scope="scope">
          <el-tag size="small" v-if="scope.row.state == 0" type="info">审核中</el-tag>
          <el-tag size="small" v-else-if="scope.row.state == 1" type="success">审核通过</el-tag>
          <el-tag size="small" v-else="scope.row.state == 2" type="danger">审核失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="申请时间"
        width="200">
      </el-table-column>
      <el-table-column
        prop="icon"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="batchSendSms(scope.row.state, scope.row.code)">群发</el-button>
          <el-divider direction="vertical"></el-divider>

          <template>
            <el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.code)">
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <!--申请短信模板-->
    <el-dialog
      title="申请短信模板"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal ="false"
      append-to-body
    >

      <el-form :model="addForm" :rules="addFormRules" ref="editForm" :label-width="'110px'">
        <!--<el-form-item label="模板类型" prop="name" label-width="140px">
          <el-input v-model="addForm.smsTemplateType" style="width: 300px"></el-input>
        </el-form-item>-->
        <el-form-item label="模板名称" prop="templateName">
          <el-input v-model="addForm.templateName" style="width: 300px" placeholder="请输入模板名称" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="模板内容" prop="templateContent">
          <el-input type="textarea" v-model="addForm.templateContent" style="width: 300px" placeholder="请输入模板内容" :rows="4" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="场景说明" prop="remark">
          <el-input type="textarea" v-model="addForm.remark" style="width: 300px" placeholder="请输入场景说明" :rows="3" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <div style="margin-left: 35px;">
          注：模板类型默认为 推广短信，只有推广短信才会有退订功能
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('editForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 群发 -->
    <el-dialog
      title="群发"
      :visible.sync="batchSendSmsVisible"
      width="500px"
      :before-close="batchSendSmsClose"
      :close-on-click-modal ="false"
      append-to-body
    >
      <el-form :model="smsForm" :rules="smsFormRules" ref="smsForm" :label-width="'110px'">
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input type="textarea" :rows="4" v-model="smsForm.phoneNumber" style="width: 300px" placeholder="请输入手机号，多个人用逗号分割"></el-input>
        </el-form-item>
        <div style="margin-left: 110px;">
          <button type="button" @click="selectUser">选择用户</button>
        </div>
        <div style="margin: 10px 110px;width: 100%;">
          <span style="color: red;">注：发送多人请用英文逗号分割</span><br>
          示例：158****6785,181****6989,******
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="smsResetForm('smsForm')">取 消</el-button>
        <el-button type="primary" @click="smsSubmitForm('smsForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 用户选择 -->
    <el-dialog title="用户选择" :visible.sync="dialogTableVisible">
      <el-form :inline="true">
        <el-form-item>
          <el-input
            v-model="userForm.name"
            placeholder="用户名"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="userDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getUserList">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="userTableData"
                           ref="multipleUserTable"
                           tooltip-effect="dark"
                           style="width: 100%"
                           @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column property="name" label="用户名" width="150"></el-table-column>
        <el-table-column property="phone" label="手机号" width="200"></el-table-column>
        <el-table-column property="organize" label="组织（公司）名称"></el-table-column>
        <el-table-column property="createTime" label="注册时间"></el-table-column>
      </el-table>
      <div style="margin-top: 20px;margin-left: 76%;">
        <el-button @click="toggleSelection()">取消选择</el-button>
        <el-button type="primary" @click="toggleSelection(userTableData)">确定选择</el-button>
      </div>
    </el-dialog>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.current"
      :page-size="page.size"
      :total="page.total">
    </el-pagination>
  </div>
</template>

<script>
  import Template from "./Template";
  export default {
    name: "SmsTemplate",
    components: {Template},
    data () {
      return {
        searchForm: {},
        options: [
          {
            value: 0,
            label: '审核中'
          },
          {
            value: 1,
            label: '审核通过'
          },
          {
            value: 2,
            label: '审核失败'
          }
        ],
        tableData: [],
        page: {
          total: 0,
          size: 10,
          current: 1,
        },
        dialogVisible: false,
        addForm: {
          smsTemplateType: 'push',
          templateName: '',
          templateContent: '',
          remark: ''
        },
        addFormRules: {
          templateName: [{required: true, message: '请输入模板名称', trigger: 'blur'}],
          templateContent: [{required: true, message: '请输入模板内容', trigger: 'blur'}],
          remark: [{required: true, message: '请输入场景说明', trigger: 'blur'}]
        },
        batchSendSmsVisible: false,
        smsForm: {
          phoneNumber: '',
          templateCode: ''
        },
        smsFormRules: {
          phoneNumber: [{required: true, message: '请至少输入一个手机号', trigger: 'blur'}]
        },
        templateCode: '',
        dialogTableVisible: false,
        userTableData: [],
        multipleSelection: [],
        userForm: {},
        userDate: [],
      }
    },
    created() {
      this.getSmsTemplateList(this.page)
    },
    methods: {
      getUserList() {
        this.$axios.post("/uxm/user/pagePhoneUser", {
          name: this.userForm.name,
          startDate: this.userDate === null ? null : this.userDate[0],
          endDate: this.userDate === null ? null : this.userDate[1],
          /*current: page == null ? this.page.current : page.current,
          size: page == null ? this.page.size : page.size,*/
        }).then(res => {
          this.userTableData = res.data.data.records
          /*this.page.size = res.data.data.size
          this.page.current = res.data.data.current
          this.page.total = res.data.data.total*/
        })
      },
      selectUser() {
        this.dialogTableVisible = true
        this.getUserList()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
          let phones = []
          this.multipleSelection.forEach(item => {
            phones.push(item.phone)
          })
          this.smsForm.phoneNumber = phones.join(',')
          this.dialogTableVisible = false
        } else {
          this.$refs.multipleTable.clearSelection();
          this.dialogTableVisible = false
        }
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.page.size = val
        this.getSmsTemplateList(this.page)
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page.current = val
        this.getSmsTemplateList(this.page)
      },
      getSmsTemplateList(page) {
        this.$axios.post("/uxm/sms-template/pageList", {
          name: this.searchForm.name,
          state: this.searchForm.state,
          current: page == null ? this.page.current : page.current,
          size: page == null ? this.page.size : page.size,
        }).then(res => {
          this.tableData = res.data.data.records
          this.page.size = res.data.data.size
          this.page.current = res.data.data.current
          this.page.total = res.data.data.total
        })
      },
      addSmsTemplate() {
        this.dialogVisible = true
      },
      batchSendSms(state, code) {
        if (state !== 1) {
          return this.$message.error("该短信模板没有审核通过，无法发送短信");
        }
        this.batchSendSmsVisible = true;
        this.templateCode = code
      },
      delHandle(code) {
        this.$axios.post("/uxm/sms-template/remove", {
          templateCode: code
        }).then(res => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          });
          this.getSmsTemplateList(this.page)
        })
      },
      handleClose() {
        this.resetForm('editForm')
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogVisible = false
        this.addForm = {}
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addForm.smsTemplateType = 'push'
            this.$axios.post("/uxm/sms-template/startAddSmsTemplate", this.addForm).then(res => {
              if (res.data.code == 200) {
                this.$message({
                  showClose: true,
                  message: '申请成功',
                  type: 'success'
                });
                this.resetForm('editForm')
                this.getSmsTemplateList(this.page)
              } else {
                this.$message.error(res.data.msg())
              }
            })
          }
        });
      },
      batchSendSmsClose() {
        this.smsResetForm('smsForm')
      },
      smsResetForm(formName) {
        this.$refs[formName].resetFields();
        this.batchSendSmsVisible = false
        this.smsForm = {
          phoneNumber: ''
        }
      },
      smsSubmitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let obj = {}
            this.smsForm.templateCode = this.templateCode
            // this.smsForm.phoneNumber = this.smsForm.phoneNumber.split(",");
            obj.templateCode = this.templateCode
            obj.phoneNumber = this.smsForm.phoneNumber.split(",")
            this.$axios.post("/uxm/sms-template/batchSendSms", obj).then(res => {
              if (res.data.code == 200) {
                this.$message({
                  showClose: true,
                  message: '群发成功',
                  type: 'success'
                });
                this.smsResetForm('smsForm')
                this.getSmsTemplateList(this.page)
              } else {
                this.$message.error(res.data.msg())
              }
            })
          }
        });
      }
    }
  }
</script>

<style scoped>
  .el-pagination {
    float: right;
    margin-top: 22px;
  }
</style>
